import React from 'react';
import type { LegalTabType } from './LegalView';
import { useLanguage } from '../context/LanguageContext';

// Social icon SVGs (inline, no extra dependency needed)
const DiscordIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
  </svg>
);

const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const TwitterXIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.2 8.2 0 0 0 4.79 1.53V6.77a4.85 4.85 0 0 1-1.02-.08z"/>
  </svg>
);



// Social links — update these when Krayson provides the real URLs
const SOCIAL_LINKS = {
  discord:   'https://discord.gg/nTNZkNdtUJ',
  youtube:   'https://www.youtube.com/@KraysonStudio',
  instagram: 'https://www.instagram.com/krayson_studio/?hl=es%2F',
  twitter:   'https://x.com/Krayson_Studio',
  tiktok:    'https://www.tiktok.com/@krayson.studio',
};

interface FooterProps {
  onNavigate: (view: 'home' | 'dashboard' | 'pricing' | 'legal' | 'guides', tab?: LegalTabType) => void;
}

export const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  const { language, t } = useLanguage();

  return (
    <footer className="border-t border-zinc-800/80 bg-[#09090b] text-zinc-500">

      {/* Main footer content */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
        <div className="flex flex-col md:flex-row items-start justify-between gap-12 sm:gap-16">

          {/* Left: Vidly branding */}
          <div className="flex flex-col gap-4 max-w-sm">
            <div className="flex items-center gap-2.5">
              <img
                src="/vidly-logo.png"
                alt="Vidly AI"
                className="w-9 h-9 object-contain invert brightness-125"
              />
              <span className="text-base font-semibold text-white tracking-tight">Vidly AI</span>
            </div>
            <p className="text-sm text-zinc-400 leading-relaxed font-normal">
              {t.footer.tagline}
            </p>

            {/* Krayson Studio credit */}
            <div className="flex items-center gap-3 p-2.5 rounded-xl bg-zinc-900/60 border border-zinc-800/80 w-fit">
              <img
                src="/krayson-logo.png"
                alt="Krayson Studio"
                className="w-7 h-7 object-contain rounded-full shadow-sm"
              />
              <div className="flex flex-col">
                <span className="text-[10px] text-zinc-500 uppercase tracking-wider font-medium">
                  {language === 'en' ? 'Built by' : 'Desarrollado por'}
                </span>
                <span className="text-xs text-white font-semibold flex items-center gap-1.5">
                  Krayson Studio
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-400"></span>
                </span>
              </div>
            </div>
          </div>

          {/* Center: Legal & Educational links */}
          <div className="flex flex-col gap-2.5">
            <span className="text-[10px] font-semibold text-zinc-400 uppercase tracking-widest mb-1">
              {t.footer.resources}
            </span>
            <button
              onClick={() => onNavigate('guides')}
              className="text-sm text-zinc-400 hover:text-white transition-colors text-left font-medium"
            >
              📚 {language === 'en' ? 'Guides & Blog Center' : 'Centro de Guías y Blog'}
            </button>
            <button
              onClick={() => onNavigate('legal', 'faq')}
              className="text-[12px] text-zinc-500 hover:text-zinc-200 transition-colors text-left"
            >
              {language === 'en' ? 'How it works (FAQ)' : 'Cómo funciona (FAQ)'}
            </button>
            <button
              onClick={() => onNavigate('legal', 'privacy')}
              className="text-[12px] text-zinc-500 hover:text-zinc-200 transition-colors text-left"
            >
              {language === 'en' ? 'Privacy & GDPR' : 'Privacidad & RGPD'}
            </button>
            <button
              onClick={() => onNavigate('legal', 'terms')}
              className="text-[12px] text-zinc-500 hover:text-zinc-200 transition-colors text-left"
            >
              {language === 'en' ? 'Terms of Service' : 'Términos de uso'}
            </button>
            <button
              onClick={() => onNavigate('legal', 'cookies')}
              className="text-[12px] text-zinc-500 hover:text-zinc-200 transition-colors text-left"
            >
              {language === 'en' ? 'Cookies & AdSense' : 'Cookies & AdSense'}
            </button>
          </div>

          {/* Right: Krayson Studio social links */}
          <div className="flex flex-col gap-3">
            <span className="text-[10px] font-semibold text-zinc-400 uppercase tracking-widest mb-1">
              Krayson Studio
            </span>

            <div className="flex flex-col gap-2">
              <a
                href={SOCIAL_LINKS.discord}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2.5 text-[12px] text-zinc-500 hover:text-[#5865F2] transition-colors group"
                aria-label="Discord de Krayson Studio"
              >
                <span className="w-7 h-7 rounded-lg bg-zinc-900 border border-zinc-800 flex items-center justify-center group-hover:border-[#5865F2]/40 group-hover:bg-[#5865F2]/10 transition-all">
                  <DiscordIcon />
                </span>
                Discord
              </a>

              <a
                href={SOCIAL_LINKS.youtube}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2.5 text-[12px] text-zinc-500 hover:text-red-500 transition-colors group"
                aria-label="YouTube de Krayson Studio"
              >
                <span className="w-7 h-7 rounded-lg bg-zinc-900 border border-zinc-800 flex items-center justify-center group-hover:border-red-500/40 group-hover:bg-red-500/10 transition-all">
                  <YouTubeIcon />
                </span>
                YouTube
              </a>

              <a
                href={SOCIAL_LINKS.instagram}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2.5 text-[12px] text-zinc-500 hover:text-pink-500 transition-colors group"
                aria-label="Instagram de Krayson Studio"
              >
                <span className="w-7 h-7 rounded-lg bg-zinc-900 border border-zinc-800 flex items-center justify-center group-hover:border-pink-500/40 group-hover:bg-pink-500/10 transition-all">
                  <InstagramIcon />
                </span>
                Instagram
              </a>

              <a
                href={SOCIAL_LINKS.twitter}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2.5 text-[12px] text-zinc-500 hover:text-zinc-100 transition-colors group"
                aria-label="Twitter/X de Krayson Studio"
              >
                <span className="w-7 h-7 rounded-lg bg-zinc-900 border border-zinc-800 flex items-center justify-center group-hover:border-zinc-400/40 group-hover:bg-zinc-400/10 transition-all">
                  <TwitterXIcon />
                </span>
                Twitter / X
              </a>

              <a
                href={SOCIAL_LINKS.tiktok}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2.5 text-[12px] text-zinc-500 hover:text-zinc-100 transition-colors group"
                aria-label="TikTok de Krayson Studio"
              >
                <span className="w-7 h-7 rounded-lg bg-zinc-900 border border-zinc-800 flex items-center justify-center group-hover:border-zinc-400/40 group-hover:bg-zinc-400/10 transition-all">
                  <TikTokIcon />
                </span>
                TikTok
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-zinc-800/60 py-4">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-[11px] text-zinc-600">
          <p>© 2026 Vidly AI. {t.footer.rights}</p>
          <p>
            {language === 'en' ? 'A product of ' : 'Un producto de '}
            <span className="text-zinc-400 font-medium">Krayson Studio</span>
            {language === 'en' ? ' · Made in Spain 🇪🇸' : ' · Hecho en España 🇪🇸'}
          </p>
        </div>
      </div>

    </footer>
  );
};
